"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function (input) {
        this.state = {
            wsClass: ' ',
            previousMode: 'auto'
        };
        this.uidx = 'ws-' + random(0, 10000);
        GState.bind(this, ['workspace']);
        GState.on('workspace', value => this.adaptView(input));
        this.adaptView(input);
    },
    adaptView: function (viewSet) {
        if (this.state.workspace.mode == this.state.previousMode && this.state.wsClass == viewSet[this.state.workspace.mode])
            return;
        switch (this.state.workspace.mode) {
        case 'fs':
            this.state.wsClass = viewSet.fs;
            break;
        case 'hs':
            this.state.wsClass = viewSet.hs;
            break;
        case 'qs':
            this.state.wsClass = viewSet.qs;
            break;
        case 'ns':
        default:
            this.state.wsClass = viewSet.ns;
        }
        this.state.previousMode = this.state.workspace.mode;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/WSAdapt/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      id: input.id,
      "class": marko_classValue(((((input.class || "") + " ") + state.wsClass) + " ws--") + state.previousMode),
      style: marko_styleValue(input.style)
    }, "@" + component.uidx, component, null, 1, {
      onclick: __component.d("click", () => component.emit('click'), false)
    });

  marko_dynamicTag(out, input.renderBody, null, null, null, null, __component, "0");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
